import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { Banner } from './banner.component';
import { IconModule } from '../icon/icon.module';
import { ButtonModule } from '../button/button.module';

export * from './banner.component';

@NgModule({
  declarations: [
    Banner
  ],
  exports: [
    Banner
  ],
  imports: [
    CommonModule,
    IconModule,
    ButtonModule,
  ]
})
export class BannerModule { }
